import { ParticipateController } from './participate-controller';
import { CONTROLLERS_MEMORY } from 'dialogs/participate-dialog/controllers-memory';
import { ParticipateModule } from 'core/interfaces';

CONTROLLERS_MEMORY.add(ParticipateModule.X50, ParticipateController);
